import {IUser} from "@dp-instant/social";
import {Avatar, ComponentClassName} from "@dp-instant/ui";
import {SVG} from "@game/ui/images";
import cn from "classnames";
import "./Winner.less";

type WinnerProps = {
    photo: string;
} & ComponentClassName;

export const Winner = ({photo, className}: WinnerProps) => {
    return (
        <div className={cn("winner-container", className)}>
            <Avatar imgPath={photo} />
            <SVG.VictoryFraming />
        </div>
    );
};
